import React from 'react'

import Layout from 'components/Layout'
import EmptyLogo from 'images/ChainXY_Improve.png'

const ChainXy_Catalogue = () => {
	return (
		<Layout>
			<Layout.Page>
				<Layout.Body>
					<div>
						<div>
							<img src={EmptyLogo} alt="" />
						</div>
					</div>
				</Layout.Body>
			</Layout.Page>
		</Layout>
	)
}

export default ChainXy_Catalogue
